import { render, staticRenderFns } from "./MarkPackPickDeliveryModal.vue?vue&type=template&id=c2a33bf4&"
import script from "./MarkPackPickDeliveryModal.vue?vue&type=script&lang=js&"
export * from "./MarkPackPickDeliveryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports